import React from 'react'
import { TextField, fieldsMap } from '@app-soga/forms'
import { ColumnConfigType } from '../../types/advanced-grid.types'
import { FilterOptionsType } from '../../types/advanced-grid.types'

interface Props {
    columnConfig?: ColumnConfigType
    fieldName: string
    filterOptions?: FilterOptionsType
    id: string
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
    value?: string | number
}

/**
 * Allows to add logic to resolve the different field types to use as filter
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @param param0
 * @returns
 */
const FilterResolver: React.FC<Props> = ({
    columnConfig,
    fieldName,
    filterOptions,
    onChange,
    id,
    value
}) => {
    const [name, type] = fieldName.split(':')
    let label = typeof columnConfig === 'object' ? columnConfig.label : columnConfig
    let FieldComponent = TextField
    let otherProps = {}
    let fieldType: string = type

    if (filterOptions) {
        label = filterOptions.label ? filterOptions.label : label
        fieldType = (filterOptions.type ? filterOptions.type : type).toString()
        otherProps = { empty: label, ...(filterOptions.InputOptions || {}) }
    }
    if (fieldType && fieldsMap[fieldType]) {
        FieldComponent = fieldsMap[fieldType]
    }

    return (
        <FieldComponent
            id={id}
            name={name}
            autoComplete="off"
            placeholder={label}
            onChange={onChange}
            value={value}
            {...otherProps}
        />
    )
}

FilterResolver.defaultProps = {
    value: ''
}

export default FilterResolver
